export default "__VITE_ASSET__54f16f96__"